export default __webpack_public_path__ + "static/media/11442 - SoccerGreg.00d7f78c.jpeg";